export default __webpack_public_path__ + "static/RunRight3-654cd04b6c54192c0b66cd7d6a2d922f.mp3";